// Register.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Modal from "../components/Modal";
import { useToast } from "../contexts/ToastContext";
import "../styles/Auth.css";
import logo from "../resources/logo.png";

function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const { showToast } = useToast();
  const navigate = useNavigate();

  function validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  async function handleRegister() {
    if (!name || !email || !password) {
      showToast("모든 필드를 입력해 주세요.");
      return;
    }

    if (!validateEmail(email)) {
      showToast("올바른 이메일 형식을 입력해 주세요.");
      return;
    }

    if (password.length < 8 || password.length > 20) {
      showToast("비밀번호는 8자리 이상 20자리 이하로 입력해 주세요.");
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_FASTAPI_URL}/register`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, password })
      });
      if (!res.ok) {
        let detail = null;
        try { detail = (await res.json())?.detail; } catch {}
        throw new Error(detail || "알 수 없는 오류가 발생했습니다.");
      }
      setConfirmModal(true);
    } catch (error) {
      showToast(error.message || "알 수 없는 오류가 발생했습니다.");
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-logo">
        <img src={logo} alt="DEVOCHAT" className="logo-image" />
      </div>
      <form className="auth-input-container" onSubmit={(e) => {
        e.preventDefault();
        handleRegister();
      }}>
        <input
          className="name field"
          type="text"
          placeholder="이름"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoComplete="name"
        />
        <input
          className="id field"
          type="email"
          placeholder="이메일"
          value={email}
          onChange={(e) => {
            const value = e.target.value;
            if (/^[a-zA-Z0-9@._-]*$/.test(value)) {
              setEmail(value);
            }
          }}
          autoComplete="username"
        />
        <input
          className="password field"
          type="password"
          placeholder="비밀번호"
          value={password}
          onChange={(e) => {
            const value = e.target.value;
            if (/^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value)) {
              setPassword(value);
            }
          }}
          autoComplete="new-password"
        />
        <p className="info">*비밀번호는 8자리 이상으로 입력해 주세요.</p>
        <button className="continue field" type="submit">회원가입</button>
      </form>
      <div className="footer">
        <p>이미 가입하셨나요?</p>
        <button className="route" onClick={() => navigate("/login")}>로그인</button>
      </div>

      <AnimatePresence>
        {confirmModal && (
          <Modal
            message="회원가입이 완료되었습니다."
            onConfirm={() => {
              setConfirmModal(false);
              window.location.href = "/";
            }}
            showCancelButton={false}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default Register;
